module.exports = __webpack_public_path__ + "img/new3-img2.4f2f8e02.jpg";